
import React from 'react';
import CityMetauxPage from '@/components/valorisation/CityMetauxPage';

const AchatMetauxAurillac = () => {
  return (
    <CityMetauxPage
      cityName="Aurillac"
      departmentName="Cantal"
      departmentCode="15"
      region="Auvergne-Rhône-Alpes"
      description="Préfecture du Cantal et ville de montagne, Aurillac bénéficie de notre expertise dans le rachat de métaux issus de l'agriculture, de l'industrie locale et des équipements de montagne."
      specialities={[
        "Métaux agricoles et d'élevage",
        "Équipements de montagne et sports d'hiver",
        "Ferraille industrielle cantalienne",
        "Métaux de construction alpine"
      ]}
      nearbyAreas={[
        "Saint-Flour", "Mauriac", "Murat", "Vic-sur-Cère", "Maurs", "Ytrac"
      ]}
      heroImage="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1280&q=80"
    />
  );
};

export default AchatMetauxAurillac;
